// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"c571c835","94":"11f3b26c","205":"35b05dcd","237":"b92c1b43","283":"aba79052","407":"a30574b9","603":"b6cdecad","998":"24b0727b"}[chunkId] + ".chunk.js";
};